import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.esm.js';
import { filterUndefined } from '@costar-ui/utils';
import { useMemo } from 'react';
import { useComponentTheme } from '../theme/theme.context.esm.js';
import { useComponentVariant } from '../theme/variant.context.esm.js';

var _excluded = ["variant"];
function useTextStyles(_ref) {
  var variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var variantProps = useComponentVariant('Text', variant);
  var theme = useComponentTheme('Text');
  var _variantProps$filterU = _objectSpread2(_objectSpread2({}, variantProps), filterUndefined(props || {})),
    _variantProps$filterU2 = _variantProps$filterU.className,
    className = _variantProps$filterU2 === void 0 ? '' : _variantProps$filterU2,
    color = _variantProps$filterU.color,
    ellipsis = _variantProps$filterU.ellipsis,
    fontFamily = _variantProps$filterU.fontFamily,
    leading = _variantProps$filterU.leading,
    size = _variantProps$filterU.size,
    tracking = _variantProps$filterU.tracking,
    weight = _variantProps$filterU.weight;
  var classes = useMemo(function () {
    return theme({
      className: className,
      color: color,
      ellipsis: ellipsis,
      fontFamily: fontFamily,
      leading: leading,
      size: size,
      tracking: tracking,
      weight: weight
    });
  }, [className, color, ellipsis, fontFamily, leading, size, theme, tracking, weight]);
  return classes;
}

export { useTextStyles as default };
//# sourceMappingURL=use-text-styles.esm.js.map
